import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
declare var $: any;
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  obj_data_all: any = [];
  obj_data: any = {};
  obj_memberkey_all: any = [];
  constructor(private util: UtilService
    , private apiService: ApiService) { }

  ngOnInit() {

    let that = this;

    var table = $('#tData').DataTable({
      "aaSorting": [],
      'columnDefs': [

        {
          'targets': 9,
          'searchable': false,
          'orderable': false,
          "className": "text-center",
          'render': function (data: any, type: any, full: any, meta: any) {
            return '<i name="delete" class="fas fa-trash" style="color: red; cursor: pointer " role="' + data + '"></i>';
          },

        },
        {
          'targets': [0, 1, 2, 3, 4, 5, 6, 7, 8],
          'width': 100
        }
      ]
      , 'scrollX': true,
    });

    $('#tData tbody').on('click', 'tr', function () {
      that.InitEdit(table.row(this).data()[0]);
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
      } else {
        table.$('tr.selected').removeClass('selected');
        $(this).addClass('selected');
      }
    });

    $('#tData tbody').on('click', 'i', function () {
      var r = confirm("ยืนยันลบสมาชิก : " + $(this).attr('role'));
      if (r == true) {
        that.DeleteMember($(this).attr('role'));
      }

    });

    $('#tDlgData').dataTable({
      'columnDefs': [
        {
          'targets': [0, 1, 2],
          "className": "text-center"
        }, {
          'targets': 0,
          'searchable': false,
          'orderable': false,
          "className": "text-center",
          'render': function (data: any, type: any, full: any, meta: any) {
            return '<input type="texebox" style="text-align:center" name="memberkey" value="' + data + '">';
          }
        },
        {
          'targets': 1,
          'searchable': false,
          'orderable': false,
          "className": "text-center",
          'render': function (data: any, type: any, full: any, meta: any) {
            return '<input type="texebox" style="text-align:center" name="expiredate" maxlength="10" data-provide="datepicker"   value="' + data + '">';
          }
        },
        {
          'targets': 2,
          'searchable': false,
          'orderable': false,
          "className": "text-center",
          'render': function (data: any, type: any, full: any, meta: any) {
            return '<i name="delete" class="fas fa-trash" style="color: red; cursor: pointer " role="' + data + '"></i>';
          }
        }]
    });


    this.InitDropDown();
  }

  BeforeSearch(){
    this.util.ShowWaiting(true);
    this.Search();
  }

  async Search() {
    this.ClearDlg();
    this.obj_data_all = [];
    this.obj_data = {};
    var table = $('#tData').DataTable();
    table.clear().draw();
    let that = this;
 
    var data = {}
    data["MEMBER_NO"] = $('#txtID').val();
    data["NAME"] = $('#txtName').val();
    data["MEMBER_TYPE"] = $('#ddlMemberType').val();
    data["STATUS"] = $('#ddlStatus').val();
    var res: any = await this.apiService.post('member', 'getmember', data);
    console.log(res);
    this.util.ShowWaiting(false);
    if (res.isSuccess) {
      if (res.responseData != null) {
        if (res.responseData.length > 0) {
          this.obj_data_all = res.responseData;
          for (var i = 0; i < res.responseData.length; i++) {

            var status = '';

            if (res.responseData[i].status == 1) {
              status = "ใช้งาน";
            } else {
              status = "ไม่ใช้งาน";
            }

            var sex = res.responseData[i].sex;
            if (this.util.GetLanguage() == 'th-TH') {
              if (sex == 'M') {
                sex = "ชาย";
              }
              if (sex == 'F') {
                sex = "หญิง";
              }
            } else {
              if (sex == 'M') {
                sex = "Male";
              } else {
                sex = "FeMale";
              }
            }
            table.row.add(
              [res.responseData[i].member_no,
              res.responseData[i].name + ' ' + res.responseData[i].surname,
              res.responseData[i].membertype_desc,
                sex,
              res.responseData[i].tel,
              res.responseData[i].email,
                status,
              res.responseData[i].update_date,
              res.responseData[i].update_user,
              res.responseData[i].member_no
              ]).draw();
          }


        }
      }

    }
  }

  InitDropDown() {
    this.InitDropDownMemberType();
    this.InitDropDownPosition();
    this.InitDropDownDepartment();

  }

  async InitDropDownMemberType() {
    var data = {}
    data["lang"] = this.util.GetLanguage();
    var res: any = await this.apiService.post('util', 'GetMemberType', data);
    if (res != null) {
      if (res.responseData != null) {
        this.util.InitDropdownAll(res.responseData, 'ddlMemberType');
        this.util.InitDropdown(res.responseData, 'ddlDlgMemberType');
      }
    }
  }

  async InitDropDownPosition() {
    var data = {}
    data["lang"] = this.util.GetLanguage();
    var res: any = await this.apiService.post('util', 'GetPosition', data);
    if (res != null) {
      if (res.responseData != null) {
        this.util.InitDropdown(res.responseData, 'ddlDlgPosition');
      }
    }
  }

  async InitDropDownDepartment() {
    var data = {}
    data["lang"] = this.util.GetLanguage();
    var res: any = await this.apiService.post('util', 'GetDepartment', data);
    if (res != null) {
      if (res.responseData != null) {
        this.util.InitDropdown(res.responseData, 'ddlDlgDepartMent');
      }
    }
  }
  Add() {
    this.ClearDlg();
    $("#txtMode").val('A');
    $('#txtDlgID').prop('disabled', false);
    $('#dlgData').modal({
      backdrop: 'static',
      keyboard: false
    });
  }
  InitEdit(x: string) {
    this.obj_data = {};
    if (this.obj_data_all != null) {
      if (this.obj_data_all.length > 0) {
        for (var i = 0; i < this.obj_data_all.length; i++) {
          if (x == this.obj_data_all[i].member_no) {
            $('#txtDlgID').val(this.obj_data_all[i].member_no);
            $('#ddlDlgMemberType').val(this.obj_data_all[i].member_type);
            $('#txtDlgName').val(this.obj_data_all[i].name);
            $('#txtDlgSurname').val(this.obj_data_all[i].surname);
            $('#txtDlgTel').val(this.obj_data_all[i].tel);
            $('#txtDlgEmail').val(this.obj_data_all[i].email);
            $('#ddlDlgPosition').val(this.obj_data_all[i].position_code);
            $('#ddlDlgDepartMent').val(this.obj_data_all[i].department_code);
            $('#ddlDlgStatus').val(this.obj_data_all[i].status);
            $('#txtDlgBirthDate').val(this.obj_data_all[i].birth_date);
            $('#txtDlgExpireDate').val(this.obj_data_all[i].expire_date).change();
            $('#ddlDlgSex').val(this.obj_data_all[i].sex);
            this.obj_data = this.obj_data_all[i];
            //  this.obj_memberkey_all = this.obj_data_all[i].listMemberKey;
            // this.InitMemberkey();
            break;
          }
        }
      }
    }
  }
  InitMemberkey() {
    var table = $('#tDlgData').DataTable();
    table.clear().draw();
    if (this.obj_memberkey_all != null) {
      if (this.obj_memberkey_all.length > 0) {

        for (var i = 0; i < this.obj_memberkey_all.length; i++) {
          table.row.add(
            [this.obj_memberkey_all[i].member_key,
            this.obj_memberkey_all[i].expire_date,
            this.obj_memberkey_all[i].member_key
            ]).draw();
        }

        let that = this;
        $('#tDlgData tbody').on('click', 'i', function () {
          table.row($(this).parents('tr')).remove().draw(false);
        });


      }
    }
  }
  AddMemberKey() {

    var table = $('#tDlgData').DataTable();
    table.row.add(
      ['',
        '',
        ''
      ]).draw();
    let that = this;
    $('#tDlgData tbody').on('click', 'i', function () {
      table.row($(this).parents('tr')).remove().draw(false);
    });
    /*
  var memberkey: any = {};
  memberkey['member_key'] = '';
  memberkey['expire_date'] = '';
  if (this.obj_memberkey_all == null) {
    this.obj_memberkey_all = [];
  }
  this.obj_memberkey_all.push(memberkey);
  this.InitMemberkey();*/
  }

  DeleteMemberKey(x: any) {
    if (this.obj_memberkey_all != null) {
      if (this.obj_memberkey_all.length > 0) {
        for (var i = 0; i < this.obj_memberkey_all.length; i++) {
          if (this.obj_memberkey_all[i].member_key == x) {
            this.obj_memberkey_all.splice(i, 1);
            this.InitMemberkey();
            break;

          }
        }

      }
    }
  }
  Edit() {

    $("#txtMode").val('E');
    $('#txtDlgID').prop('disabled', true);
    if ($('#txtDlgID').val() != '' && $('#txtDlgID').val() != null
      && $('#txtDlgID').val() != 'null') {
      $('#dlgData').modal({
        backdrop: 'static',
        keyboard: false
      })
    } else {
      this.util.ErrorDialog('กรุณาเลือกรายการที่ต้องการแก้ไข');
    }
  }
  ClearDlg() {
    this.obj_data = {};
    $("#divCusError").hide();
    $('#txtDlgID').val('');
    $("select#ddlDlgMemberType")[0].selectedIndex = 0;
    $('#txtDlgName').val('');
    $('#txtDlgSurname').val('');
    $('#txtDlgTel').val('');
    $('#txtDlgEmail').val('');
    $('#txtDlgPassword').val('');
    $("select#ddlDlgPosition")[0].selectedIndex = 0;
    $("select#ddlDlgDepartMent")[0].selectedIndex = 0;
    $("select#ddlDlgStatus")[0].selectedIndex = 0;
    $('#txtDlgBirthDate').val('');
    $('#txtDlgExpireDate').val('');
    $('#ddlDlgSex').val('M');
    var table = $('#tDlgData').DataTable();
    table.clear().draw();
    this.obj_memberkey_all = null;
  }

  async Save() {
    if (this.util.ValidateForm()) {
      let that = this;
      var data = {};
      if ($("#txtMode").val() == 'A') {
        data["MEMBER_NO"] = $('#txtDlgID').val();
        data["PASSWORD"] = $('#txtDlgPassword').val();
        data["MEMBER_TYPE"] = $('#ddlDlgMemberType').val();
        data["NAME"] = $('#txtDlgName').val();
        data["surname"] = $('#txtDlgSurname').val();
        data["TEL"] = $('#txtDlgTel').val();
        data["EMAIL"] = $('#txtDlgEmail').val();
        data["POSITION_CODE"] = $('#ddlDlgPosition').val();
        data["DEPARTMENT_CODE"] = $('#ddlDlgDepartMent').val();
        data["STATUS"] = $('#ddlDlgStatus').val();
        data["SEX"] = $('#ddlDlgSex').val();
        data["UPDATE_USER"] = this.util.GetUserID();
        data["BIRTH_DATE"] = $('#txtDlgBirthDate').val();
        data["EXPIRE_DATE"] =$('#txtDlgExpireDate').val() ;
      } else {
        data = this.obj_data;
        data["PASSWORD"] = $('#txtDlgPassword').val();
        data["MEMBER_TYPE"] = $('#ddlDlgMemberType').val();
        data["NAME"] = $('#txtDlgName').val();
        data["surname"] = $('#txtDlgSurname').val();
        data["TEL"] = $('#txtDlgTel').val();
        data["EMAIL"] = $('#txtDlgEmail').val();
        data["POSITION_CODE"] = $('#ddlDlgPosition').val();
        data["DEPARTMENT_CODE"] = $('#ddlDlgDepartMent').val();
        data["STATUS"] = $('#ddlDlgStatus').val();
        data["SEX"] = $('#ddlDlgSex').val();
        data["UPDATE_USER"] = this.util.GetUserID();
        data["BIRTH_DATE"] = $('#txtDlgBirthDate').val();
        data["EXPIRE_DATE"] =$('#txtDlgExpireDate').val() ;
      }

      var check = 0;
      // var list_memberkey: any = [];
      // $("#tDlgData tbody tr").each(function () {
      //   var member_key = $(this).children().eq(0).children().eq(0).val();
      //   var expire_date = $(this).children().eq(1).children().eq(0).val();


      //   if (member_key == '' || member_key == null) {
      //     check++;
      //   }

      //   if (expire_date == '' || expire_date == null) {
      //     check++;
      //   }

      //   if (check == 0) {
      //     var memberkey: any = {};
      //     memberkey['member_no'] = $('#txtDlgID').val();
      //     memberkey['member_key'] = member_key;
      //     memberkey['expire_date'] = that.util.DateToDB(expire_date, ' 23:59:59');
      //     memberkey['key_status']=1;
      //     list_memberkey.push(memberkey);
      //   }

      // });
      if (check == 0) {
        // data['listMemberKey'] = list_memberkey;
        var res: any = await this.apiService.post('member', 'InsertUpdateMember', data, $("#txtMode").val());
        if (res != null) {
          if (res.isSuccess) {
            this.util.SuccessDialog('บันทึกสำเร็จ');
            $('#dlgData').modal('hide');
            this.ClearDlg();
            this.Search();
          } else {
            this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
          }
        } else {
          this.util.ErrorDialog('System Error');
        }
      } else {
        this.util.ErrorDialog('กรอกค่าไม่ครบถ้วน');
      }
    }
  }

  async DeleteMember(member_no: any) {

    let that = this;
    var data = {};
    data["MEMBER_NO"] = member_no;

    var res: any = await this.apiService.post('member', 'DeleteMember', data);
    if (res != null) {
      if (res.isSuccess) {
        this.util.SuccessDialog('บันทึกสำเร็จ');
        this.Search();
      } else {
        this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
      }
    } else {
      this.util.ErrorDialog('System Error');
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/member/register/register.component.ts